import Link, { LinkProps } from 'next/link';
import React from 'react';

const checkPhpResource = (url: string): boolean => {
  const [hostWithPath] = url.split('?');
  return hostWithPath.lastIndexOf('.php') !== -1;
};

export default function NextLink(props: React.PropsWithChildren<LinkProps>) {
  const { href, children } = props;
  const hrefStr = href.toString();
  const isPhpResource = checkPhpResource(hrefStr);
  if (isPhpResource) {
    return <a href={hrefStr}>{children}</a>;
  }
  return <Link {...props}>{children}</Link>;
}
